<template lang="pug">
  div.home
    Landing 
    Video
    Concepts
    Caroucel
    Points(title="Ticketeer smart contract" 
          :bgIconStyle="{ color: 'rgba(113,140,209, 0.45)', width: 500 + 'px', transform: 'translateX(45px)'  }" :bgIcon="['fad', 'file-signature']" 
          :listIcon="['fad', 'hand-holding-magic']" listIconColor="#718CD1" 
          subTitle="The future heart of ticket sales." :points="smartContractPoints")
    .features-wrap
      Points.features(title="Features" 
      :bgIconStyle="{ color: 'rgba(255,255,255, 0.40)', width: 250 + 'px'  }" 
      :bgIcon="['fad', 'box-heart']" :listIcon="['fad', 'gem']" listIconColor="#FFFFFF" :points="features" note="Always remember to protect and educate your customers.")
    Points(title="Integration with wallet applications" 
          :bgIconStyle="{ color: 'rgba(113,140,209, 0.45)', width: 225 + 'px' }" 
          :bgIcon="['fad', 'mobile-android']" 
          :listIcon="['fad', 'wallet']" listIconColor="#718CD1" 
          subTitle="Ticketeer is expected to work in close relation with wallet applications." :points="wallets")
    Footer
</template>

<script>
// @ is an alias to /src
import Landing from '@/components/Landing.vue'
const Video = () => import('@/components/Video.vue')
const Concepts = () => import('@/components/Concepts.vue')
const Caroucel = () => import( '@/components/Caroucel.vue')
const Points = () => import('@/components/Points.vue');
const Footer = () => import('@/components/Footer.vue');
//const ConfirmDialog = () => import("@/components/dialogs/ConfirmDialog.vue");

export default {
  name: 'Home',
  components: {
    Landing,
    Video,
    Concepts,
    Caroucel,
    Points,
    Footer
  },
  data: () => ({
    smartContractPoints: [
      { title: "Designed for event of any kind", subTitle: "One contract to cover entire event industry." },
      { title: "All-in-one contract", subTitle: "All features you may ever need." },
      { title: "AGPL licensed", subTitle: "Transparent and consistent development of the contract for everyone." }
    ],
    features: [
      { title: "Resellers", subTitle: "You can choose to provide ticket sales trough resellers, while maintaining security for your customers." },
      { title: "Ticket verification", subTitle: "To verify your customers during the event you can use built-in verification system.*" },
      { title: "Refunds", subTitle: "Simple way to configure refund parameters according to your needs." }
    ],
    wallets: [
      { title: "All necesarry customer operations", subTitle: "Buy, buy as gift, transfer or refund - all are supported." },
      { title: "Distributed PoS", subTitle: "Expose sales of your tickets to all people over the world integrated into cryptocurrency wallets." },
      { title: "Easy and consistent", subTitle: "User friendly access to all of your event sales." },
    ]
  })
}
</script>

<style lang="stylus" >
.features-wrap 
  background-color #718CD1

  .features 
    color white !important
    h2
      color white !important
    p
      color white !important
</style>
